import React from 'react';
import './index.less';

import reject from 'lodash/reject';
import sumBy from 'lodash/sumBy';

import PayoutAmount from '../components/payout-amount';

import { enum as payoutStatuses } from '../../../../../../../../../../enums/payout-statuses';

function PayoutSumRow({ payouts, payoutSystem, isToPayColumnShouldBeShown }) {
	const notConfirmedPayouts = reject(payouts, { status: payoutStatuses.confirmed });

	return (
		<tr className='payout-table--body--sum-row'>
			<td colSpan={5}>
				<span className='font-proxima-nova-bold'>
					Total:
				</span>
			</td>
			<td className='text-align-right'>
				<PayoutAmount
					amount={sumBy(notConfirmedPayouts, 'amount')}
					currency={payoutSystem.currency}
					keepDecimals={payoutSystem.allow_floats}
				/>
			</td>
			{isToPayColumnShouldBeShown && (
				<td className='text-align-right'>
					<PayoutAmount
						amount={sumBy(notConfirmedPayouts, 'amount_to_pay')}
						currency={payoutSystem.currency}
						keepDecimals={payoutSystem.allow_floats}
					/>
				</td>
			)}
			<td colSpan={5} />
		</tr>
	);
}

export default PayoutSumRow;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/table/components/payout-body/payout-sum-row/index.js